import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from './apiDictionary';
import { getClient } from './client';
import type { CalculateFirstVisitScoringResult } from './firstVisitScoring';

export type CalculatePreviousVisitScoringArgs = {
  clinicalTrialId: string;
  parentTaskId: string;
  taskId: string;
};

export type CalculatePreviousVisitScoringResult =
  CalculateFirstVisitScoringResult;

export const calculatePreviousVisitScoring = (
  args: CalculatePreviousVisitScoringArgs
) => {
  const api = getClient(API_URL.readerParentTaskCalculatePreviousVisitScoring);

  return api.get<CalculatePreviousVisitScoringResult>(
    prepareUrl(API_URL.readerParentTaskCalculatePreviousVisitScoring, [
      args.parentTaskId,
      args.taskId,
    ]),
    {
      headers: {
        'x-dynamika-clinical-trial-id': args.clinicalTrialId,
      },
    }
  );
};
